// Module
var code = "<div id=\"V-FCF71354-5C2A-450C-8E2F-7A1DD4A82AB0\"> <div data-b-component=\"button\" class=\"primary button\" data-b-event-click=\"{Binding edit}\">ویرایش</div> </div> ";
// Exports
export default code;